import { DensityNetworkConfigTable } from './DensityNetworkConfigTable';
import { Box, Button, Typography } from '@mui/material';

const DensityNetworkConfigs = () => {

    const UploadDensityNetworkConfigButton = () =>
        <Button
            sx={{ marginLeft: '20px' }}
            variant="contained"
            href={"upload-density-network-config?base-id=null"}
        >
            Upload Density Network Config
        </Button>
    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Box>
                    <Typography variant="h6">Base Density Network Configs</Typography>
                </Box>
                <Box>
                    <UploadDensityNetworkConfigButton />
                </Box>
            </Box>
            <div style={{ height: '800px' }}>
                <DensityNetworkConfigTable parent_id={undefined} />
            </div>
        </div>
    )
}

export default DensityNetworkConfigs;